import React from 'react';

import './index.scss';

const OptionalIcon = ()=> {
  return( 
    <div className="optional">任意</div>
  );
};

export default OptionalIcon;